import { Component, Input, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DsStep, DsStepperComponent, DsStepState } from '@customdesignsystem';
import {
  STEPPER_TEXTS,
  SUBSCRIPTION_STEPS,
} from '../../constants/stepper.constant';

@Component({
  selector: 'app-stepper-lateral',
  templateUrl: './stepper-lateral.component.html',
  styleUrl: './stepper-lateral.component.scss',
  imports: [CommonModule, DsStepperComponent],
})
export class StepperLateralComponent implements OnChanges {
  @Input() currentStep: number = 0;

  readonly steps = SUBSCRIPTION_STEPS;
  dsSteps: DsStep[] = this.buildSteps();
  isExpanded: boolean = false;

  get summary(): string {
    return STEPPER_TEXTS.summary
      .replace('{step}', `${this.currentStep + 1}`)
      .replace('{total}', `${this.steps.length}`);
  }

  ngOnChanges(): void {
    this.dsSteps = this.buildSteps();
  }

  stepStatus(index: number): DsStepState {
    if (index < this.currentStep) return 'complete';
    if (index === this.currentStep) return 'current';
    return 'incoming';
  }

  toggle(): void {
    this.isExpanded = !this.isExpanded;
  }

  private buildSteps(): DsStep[] {
    return this.steps.map((step, index) => ({
      title: step.title,
      description: step.description,
      state: this.stepStatus(index),
    }));
  }
}
